export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9256.77037f94.jpg";